import { ConnectionProvider } from "@common/types/integrationConnection";
import {
    ConnectionButtonSize,
    ConnectionButtonVariant,
} from "@components/financialConnection/ConnectionActionButton";
import { AddAccountProps } from "../accounts/AddAccounts/lib";
import { CreatePayPalConnection } from "../paypal/CreatePayPalConnection";
import { CreateGustoConnection } from "../gusto/CreateGustoConnection";
import { CreateStripeConnection } from "../stripe/CreateStripeConnection";

interface Props extends AddAccountProps {
    provider: ConnectionProvider;
    children?:
        | React.ReactNode
        | ((props: {
              connecting: boolean;
              initializeConnection: () => void;
          }) => React.ReactNode);
    btnVariant?: ConnectionButtonVariant;
    btnSize?: ConnectionButtonSize;
}

export const NewIntegrationConnection: React.FC<Props> = ({
    provider,
    ...rest
}) => {
    if (provider === ConnectionProvider.PAYPAL) {
        return <CreatePayPalConnection {...rest} />;
    }
    if (provider === ConnectionProvider.GUSTO) {
        return <CreateGustoConnection {...rest} />;
    }
    if (provider === ConnectionProvider.STRIPE) {
        return <CreateStripeConnection {...rest} />;
    }
};
